/**
 * Created by Denis Kuzin on 02 april 2025
 */

const Merge2StartFixTutorial = function () {
    return new TutorialScenario("merge2_start_fix_tutorial", {
        listSteps: Merge2StartFixTutorial.listSteps,

        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
        },

        isAvailable: function () {
            const location = cleverapps.meta.getSelectedLocation();

            return location.getContinuousStage() === 0
                && Merge2.current && Merge2.current.mode === Merge2.MODE_GAME
                && !Merge2.current.counter.isActive()
                && location.stars.getAmount() >= location.calcStarsForStage();
        }
    });
};

Merge2StartFixTutorial.listSteps = function () {
    return [
        Merge2TutorialHelper.createWaitRowStep("new_task"),
        Merge2TutorialHelper.createDelayStep(500),
        Merge2TutorialHelper.createOpenTaskWindowStep({
            text: "Merge2.StartFixTutorial"
        }),
        Merge2TutorialHelper.createRepairStep(),

        Merge2TutorialHelper.createCompleteRepairAnimationStep(),
        Merge2TutorialHelper.createSwitchStep({
            mode: Merge2.MODE_GAME
        })
    ];
};
